module.exports = __webpack_public_path__ + "static/rust_monster-d26f994727b6fb457433fba4115e594a.jpg";